/**
 * @file   src\components\ProtectedRoute.tsx
 * @brief  This component used for manage and protect unauthorized/permission based url access.
 * @date   JULY, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import {React,  Navigate, useLocation,  useParams, matchPath, useNavigate } from '../utils/thirdpartyComponents';
import { getFromLocalStorage } from '../utils/helper';
import { pageURLs } from '../utils/pageUrls';
import Cookies from 'js-cookie';
import { Session } from 'inspector';

interface Props {
  children: JSX.Element;
  // any props that come into the component
}
const ProtectedRoute = ({ children }: Props) => {
  
  const params = useParams();
  const navigate = useNavigate()
  /* Create location object to access location info. */
  const storageData = getFromLocalStorage('CARWASH_ADMIN_DATA');
  const userInfo = storageData && storageData !== null ? storageData : null;
  const isAuthenticated = userInfo !== null && Cookies.get('accessToken')!== '';

  /* Check whether the user is authenticated or not and redirected to login page. */
  if (!isAuthenticated) {
    return <Navigate to={`/superadmin/${pageURLs.root}`}  replace />;
  }
  else  if(userInfo?.userTypeId == 2 && userInfo?.permissionType == 2 && IsSubadminAllowed()==null){
     navigate("/superadmin/"+pageURLs.manage_carwash)
  }
   else {
    localStorage.removeItem('CARWASH_OWNER_DATA');
  }

  return children;
};

const IsSubadminAllowed = ()=> {
  const subadminallowed_urls = [
    pageURLs.my_profile,
    pageURLs.order_list,
    pageURLs.order_details,
    pageURLs.manage_carwash,
    pageURLs.add_carwash,
    pageURLs.edit_carwash,
    pageURLs.signup_process
  ]
  const  pathname  = useLocation().pathname;
  let patern = null;
  subadminallowed_urls.forEach((val: string) => {
    const patern1 = matchPath({ path: '/superadmin/'+val, end: false }, pathname);
    if (patern1 != null) {
      patern = patern1;
      return patern;
    }
  });

  return patern;
  
}
export default ProtectedRoute;
